import React from 'react';
import PropTypes from 'prop-types';
import SeoHead from '../seo';
import { withTranslation } from '../../lib/i18n';

const MatchCentrePageTitle = ({
  activeSection,
  fixtureId,
  overview,
  t,
  team: { id: teamId, name: teamName },
}) => {
  let titleKey = 'common:loading_title';
  let translationValues = {};

  if (overview) {
    titleKey = 'teams:match_billing_page_title';
    translationValues = {
      team: teamName,
      opponent: overview.ha === 'h' ? overview.away.name : overview.home.name,
      ha: overview.ha,
      section: t(`teams:${activeSection}_page_title_slug`),
    };

    if (overview.home.score !== null && overview.away.score !== null) {
      titleKey = 'teams:match_result_page_title';
      translationValues = {
        ...translationValues,
        homeTeam: overview.home.name,
        homeScore: overview.home.score,
        awayTeam: overview.away.name,
        awayScore: overview.away.score,
      };
    }
  }

  return (
    <SeoHead
      route={`team.match_centre.${activeSection}`}
      routeParams={{ fixtureId, teamId }}
      titleTranslationKey={titleKey}
      translationValues={translationValues}
    />
  );
};

MatchCentrePageTitle.propTypes = {
  activeSection: PropTypes.string.isRequired,
  fixtureId: PropTypes.string.isRequired,
  overview: PropTypes.shape({
    ha: PropTypes.string,
    home: PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.string,
    }),
    away: PropTypes.shape({
      name: PropTypes.string.isRequired,
      score: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
  team: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default withTranslation(['common', 'teams'])(MatchCentrePageTitle);
